/**
 * The display host for a favicon lookup.
 *
 * The www strip is anchored. It used to be `.replace("www.", "")` with a plain
 * string, which String.replace matches ANYWHERE in the host: notwww.example.com
 * came back as "notexample.com" and asked Google for a favicon for a domain
 * that does not exist.
 */
export function hostOf(url) {
  try {
    return new URL(url).hostname.replace(/^www\./i, "");
  } catch {
    return null;
  }
}

/** The letter shown when there is no favicon to show. */
export function monogramOf(outlet) {
  return (outlet || "?").trim().charAt(0).toUpperCase() || "?";
}

/**
 * Whether an article URL belongs to an outlet profile's canonical domain.
 *
 * Used only to pick this outlet's scans out of the global recent list, which
 * carries a `url` and no `outlet_domain` — see the "Known gap" note in
 * docs/api-outlets.md. It is deliberately a best-effort match and not a second
 * implementation of the server's normalisation: the suffix test covers the
 * subdomain cases the contract names (www., amp., m., edition.), but the alias
 * table that folds bbc.co.uk onto bbc.com lives server-side and is not
 * reproduced here. A miss shows one fewer row; it never shows a wrong one.
 */
export function isOutletUrl(url, domain) {
  const host = hostOf(url);
  const d = (domain || "").trim().toLowerCase();
  if (!host || !d) return false;
  return host === d || host.endsWith(`.${d}`);
}
